export default "__VITE_ASSET__DUy58et4__"